module.exports = __webpack_public_path__ + "static/image-mirandas-signature-3203467685711b00c3263dca76bf899c.svg";